import React, {Component} from "react";
import DataTable from "react-data-table-component";
import {NavLink as Links} from "react-router-dom";

export default class ReportTable extends Component {
  constructor(props) {
    super(props);
    const typeData =
      this.props.type.charAt(0).toUpperCase() + this.props.type.slice(1);
    this.state = {
      tableData: props.data,
      title: typeData,
      filterText: "",
    };
    this.columns = [
      {
        name: "Products",
        selector: row => row.name,
        sortable: true,
        width: "300px",
        cell: (row) => {
          return (
            <Links to={`../../Inventory/Products/View/${row.id}`}>
              {row.name}
            </Links>
          );
        },
      },
      {
        name: typeData,
        selector: row => row.total,
        sortable: true,
      },
      {
        name: "Return",
        selector: row => row.return,
        sortable: true,
      },
      {
        name: "Damage",
        selector: row => row.damage,
        sortable: true,
      },
      {
        name: `Avg.${typeData}`,
        selector: row => row.avgtotal,
        sortable: true,
      },
      {
        name: "Avg.Return",
        selector: row => row.avgReturn,
        sortable: true,
      },
      {
        name: "Avg.Damage",
        selector: row => row.avgDamage,
        sortable: true,
      },
      ];
  }

  customStyles = {
    headCells: {
      style: {
        padding: "12px 16px",
        fontWeight: "bold",
        fontSize: "14px",
        backgroundColor: "#f8f9fa",
      },
    },
    cells: {
      style: {
        padding: "10px 16px",
        fontSize: "13px",
      },
    },
  };

  render() {
    const filteredData = this.state.tableData.filter(item =>
      Object.values(item).some(val =>
        String(val).toLowerCase().includes(this.state.filterText.toLowerCase())
      )
    );
    return (
      <div className="card">
        <h4 className="card-title">
          <strong>Details Table </strong> <small> {this.state.title}</small>
        </h4>
        <div className="card-body">
          <div className="dataTables_wrapper">
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Search..."
                onChange={e => this.setState({ filterText: e.target.value })}
              />
            </div>
            <DataTable
              className="table table-separated"
              keyField="id"
              columns={this.columns}
              data={filteredData}
              pagination
              paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
              paginationPerPage={10}
              customStyles={this.customStyles}
              filter
              exportable
            />
          </div>
        </div>
      </div>
    );
  }
}
